import { Script } from 'gatsby'
import { useLocale } from '@hooks/useLocale'
import { useHeaderFooter } from '@hooks/useHeaderFooter'
import Header from '@components/layout/header'
import PinnedCTA from './pinnedCTA'

const HeaderFooterUbisoft = ({ children, isResultsPage, landing, results }) => {
  const locale = useLocale()

  return useHeaderFooter() ? (
    <>
      <div className="relative flex flex-col justify-between overflow-hidden">
        {children}
      </div>
      <PinnedCTA landing={landing} results={results} show={isResultsPage} />
    </>
  ) : (
    <div>
      <Script
        src="https://static-dm.ubisoft.com/global-navigation-prod/prod/1/global-navigation.js?id=global-navigation&type=text/javascript"
        strategy="idle"
      />
      <div className="relative flex min-h-screen flex-col justify-between overflow-hidden">
        {children}
      </div>
      <PinnedCTA landing={landing} results={results} show={isResultsPage} />
      <div>
        <global-footer
          locale={locale && locale.toLowerCase()}
          class="global-footer--default"
          open-in-same-window="true"
          language-selector-locales="en-us,en-gb,en-au,en-ca,fr-fr,fr-ca,it-it,de-de,es-es,es-mx"
          // language-selector-url={`https://ubisoft.com${getLocalizedSitePath(
          //   locale
          // )}`}
        />
      </div>
    </div>
  )
}

const Layout = ({
  children,
  location,
  isResultsPage,
  logo,
  landing,
  results,
}) => {
  return (
    <HeaderFooterUbisoft
      isResultsPage={isResultsPage}
      landing={landing}
      results={results}
    >
      <Header logo={logo} />
      <main className="flex flex-1">{children}</main>
    </HeaderFooterUbisoft>
  )
}

export default Layout
